import { render, staticRenderFns } from "./OrganisationUnit.vue?vue&type=template&id=265b4eb3&"
import script from "./OrganisationUnit.vue?vue&type=script&lang=ts&"
export * from "./OrganisationUnit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports